let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("5K0AN")).then(() => parcelRequire('kMjxR'));